

import map from 'lodash/map';

const
braceElementCollection = document.querySelectorAll('.brace'),
popupDownload = document.querySelector('.popup.download'),
activatorBtn = document.createElement('span'),
scriptCollection = document.querySelectorAll('script'),
paginationContainer = document.createElement('nav'),
paginationElement = document.createElement('a');

let rtn = {};
	
/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
const insertButton = (el) => {

	if (el.dataset.title) {
		const button = paginationElement.cloneNode(true);
		button.href = '#' + el.id;
		button.innerHTML = el.dataset.title;
		paginationContainer.appendChild(button);
	}

}


const activateMenu = (e) => {

	e.preventDefault();
	paginationContainer.classList.toggle('active');

}


/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param  [description]
 * @return [description]
 */
rtn.init = () => {

	//style the activator button
	activatorBtn.classList.add('btn');
	activatorBtn.classList.add('activator');
	activatorBtn.innerHTML = 'shortcut menu';

	paginationContainer.appendChild(activatorBtn);
	activatorBtn.addEventListener('click', activateMenu, false);

	//provide styling
	paginationContainer.classList.add('nav');
	paginationContainer.classList.add('pagination');

	//insert into body
	document.body.appendChild(paginationContainer);

	//run through the brace collection and create buttons in the paginator
	map(braceElementCollection, insertButton);

	//if a popup download exists then move it into the pagination
	if(popupDownload) {
		paginationContainer.appendChild(popupDownload);
	}

	return this;

}



module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/pagination.js